module.exports = __webpack_public_path__ + "img/img_shop_error.a02c5747.png";